import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsDisplayView, ProjectsReducerCreator } from '../types';

const setProjectsDisplayViewReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<ProjectsDisplayView>) => {
    state.projectsDisplayView = action.payload;
  });
};

export default setProjectsDisplayViewReducer;
